import React, { useState } from 'react'
import Srcset from '@/components/common/Srcset';
import { validatePassword } from '@/helpers/generalHelper';
import { errorMessages } from "@/utils/constants";
import InputField from "@/components/common/CommonInputComponent";
function EditPassword(props) {

  const [password, setNewPassword] = useState();
  const [confirmNewPassword, setConfirmNewPassword] = useState();
  const [confirmError, setConfirmError] = useState();
  const [passwordErrorMessage, setPasswordErrorMessage] = useState(false);
  const [passwordType, changePasswordType] = useState(true);
  const [confirmPasswordType, changeConfirmPasswordType] = useState(true);
  const { successMsg, styles, loading, submitFormEdit, setSuccessMessage } = props;
  let validatePass;

  const handleSubmit = () => {
    if (password && confirmNewPassword) {
      if (!confirmError && !passwordErrorMessage)
        submitFormEdit({
          password: password
        })
    }
    else {
      handlePasswordFormat();
      confirmPasswordMatch();
    }
  }
  const confirmPasswordMatch = () => {
    if (password == confirmNewPassword) {
      setConfirmError(null);
    }
    else {
      setConfirmError(errorMessages.authentication.passWordMatchError);
    }
  }
  const handlePasswordFormat = value => {
    if (value) {
      validatePass = validatePassword(value);
      if (!validatePass) {
        setPasswordErrorMessage(true);
      } else {
        setPasswordErrorMessage(false);
      }
    } else {
      setPasswordErrorMessage(errorMessages.authentication.emptyPassword);
    }
  }

  const togglePasswordVisibility = () => {
    changePasswordType(!passwordType);
  };
  const toggleConfirmPasswordVisibility = () => {
    changeConfirmPasswordType(!confirmPasswordType);
  };

  return (
    <div className={`${styles.account_card} edit_details wrapper`}>
      <div className="item-wrapper mb-30">
      <InputField
          type={passwordType ? "password" : "text"}
          id="new_password"
          name="new_password"
          label="New password"
          placeholder=" "
          autoComplete='password'
          ariaLabel='new-password'
          className={`normal-md small-xs normal-sm ${confirmError ? " border-error" : ""}`}
          errorMessage={passwordErrorMessage}
          onChange={e => {
            setNewPassword(e.currentTarget.value);
            setSuccessMessage('')
          }}
          onBlur={e => {
            handlePasswordFormat(e.target.value);
          }}
          isPassword={true}
          togglePasswordVisibility={togglePasswordVisibility}
          isPasswordVisible={!passwordType}
          isEditTab={true}
        />
      </div>
      <div className="item-wrapper mb-30">
      <InputField
          type={confirmPasswordType ? "password" : "text"}
          id="confirm_password"
          name="confirm_password"
          label="Confirm password"
          placeholder=" "
          autoComplete='password'
          ariaLabel='confirm-password'
          className={`normal-md small-xs normal-sm ${confirmError ? " border-error" : ""}`}
          errorMessage={confirmError}
          onChange={e => {
            setConfirmNewPassword(e.currentTarget.value);
            setSuccessMessage('');
          }}
          onBlur={e => {
            confirmPasswordMatch();
          }}
          value={confirmNewPassword}
          isPassword={true}
          successMsg={successMsg}
          togglePasswordVisibility={toggleConfirmPasswordVisibility}
          isPasswordVisible={!confirmPasswordType}
          isEditTab={true}
          isConfirmPassword={true}
        />
      </div>
      <button className={`btn-primary w-full btn_loading ${loading ? "loading" : ""}`} onClick={handleSubmit}>
        <span>Save</span>
      </button>
    </div>
  )
}

export default EditPassword
